<template>
  <label
    :class="classes"
    @mouseover.stop='isHover = true'
    @mouseleave='isHover = false'
    @click.stop="$emit('click')">
    <slot/>
  </label>
</template>


<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default'
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      isHover: false,
    }
  },

  computed: {
    classes() {
      return {
        'mr-3' : true,
        'disabled' : this.disabled,
        [`${this.type}`] : !this.disabled && true,
        [`${this.type}--active`] : this.active,
        [`${this.type}--hover`] : this.isHover && !this.active,
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  label
    box-shadow 0px 2px 2px rgba(0,0,0,0.29)
    font-weight bold
    text-align center
    display inline-block
    padding 0
    margin 5px 5px 0 0 !important
    width 15em
    height 50px
    line-height 50px
    border-radius 3px
    cursor pointer
    position relative
    outline: none;
    position: relative;
    opacity: .6;

  types = {
    'midashi': {
      'background-color': #c44c32,
      'box-shadow-color': #8a1c1c,
    },
    'ouyou': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },
    'theme': {
      'background-color': #49A26E,
      'box-shadow-color': #2c5e41,
    },

    'publisher': {
      'background-color': #c44c32,
      'box-shadow-color': #8a1c1c,
    },
    'getThrough': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },

    'eiwa': {
      'background-color': #c44c32,
      'box-shadow-color': #8a1c1c,
    },
    'waei': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },

    'page': {
      'background-color': #c44c32,
      'box-shadow-color': #8a1c1c,
    },
    'tangen': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },
    'random': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },

    'tango': {
      'background-color': #c44c32,
      'box-shadow-color': #8a1c1c,
    },
    'rengo': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },

    'midashi-range': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },
    'have_description': {
      'background-color': #c44c32,
      'box-shadow-color': #8a1c1c,
    },
    'no_description': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },
    'have_logo': {
      'background-color': #c44c32,
      'box-shadow-color': #8a1c1c,
    },
    'no_logo': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },
  }

  for type, values in types
    .{type}
      background-color values['background-color'];
      color white
      border-radius 10px
      box-shadow 0px 6px values['box-shadow-color'];

      &--active
        box-shadow: 0 0 values['box-shadow-color'];
        top: 6px;
        opacity: 1;

      &--hover
        box-shadow: 0 4px values['box-shadow-color'];
        top: 2px;
        opacity: 1;

  .disabled
    background-color: #959595;
    color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 #5c5c5c;
    top: 6px;
</style>
